import { formatMoney } from './currency';

export const formatMoneyIfSupportedCurrency = (price, intl) => {
  if (!price) {
    return null;
  }
  try {
    return formatMoney(intl, price);
  } catch (e) {
    return price.currency ? `(${price.currency})` : null;
  }
};
